import React from 'react';
import { autobind } from 'core-decorators';
import { Row, Col } from 'src/componentes/grid';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import ResponsavelLookup from 'src/lookups/colaborador';
import { capitalizeFirstLetter } from 'src/utils/string';

@autobind
class DesdobramentoSearch extends React.Component {
  render() {
    let { model, resources, intl } = this.props;
    return (
      <Row>
        <Col md={12}>
          <Input model={model.getModel('idIntegracao')} />
        </Col>
        <Col md={12}>
          <Input model={model.getModel('descricao')} />
        </Col>
        <Col md={12}>
          <ItemOrganizacaoLookup
            multi
            model={{
              label: capitalizeFirstLetter(resources.areas),
              value: model.getModel('area').value,
              requestChange: model.getModel('area').requestChange,
            }}
            data={{ tiposIdSelecionaveis: [1, 2, 3] }}
          />
        </Col>
        <Col md={12}>
          <Checkbox
            model={{
              label: intl.formatMessage({ id: 'label.considerarAreasSubordinadas' }, { areas: resources.areas }),
              value: model.getModel('areasSubordinadas').value,
              requestChange: model.getModel('areasSubordinadas').requestChange,
            }}
            disabled={!model.getModel('area').value}
            style={{ marginTop: 9, marginBottom: 19 }}
          />
        </Col>
        <Col md={12}>
          <ResponsavelLookup
            multi
            model={{
              label: capitalizeFirstLetter(resources.responsaveis),
              value: model.getModel('responsaveis').value,
              requestChange: model.getModel('responsaveis').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <ResponsavelLookup
            multi
            model={{
              label: capitalizeFirstLetter(resources.digitadores),
              value: model.getModel('digitadores').value,
              requestChange: model.getModel('digitadores').requestChange,
            }}
          />
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(DesdobramentoSearch));
